'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogAdIfNeeded = exports.isCatalogAdLoading = exports.getLoadTimeForCatalogAd = exports.getAd = exports.getAdByKeyword = exports.getAdById = exports.LOAD_CATALOG_AD_SUCCESS = exports.LOAD_CATALOG_AD_REQUEST = exports.LOAD_CATALOG_AD_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('../modules/config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REDUX_STORE_TIME = (0, _ms2.default)('3m');

/* Action Types */
var LOAD_CATALOG_AD_FAIL = exports.LOAD_CATALOG_AD_FAIL = 'la/domain/catalogAds/LOAD_FAIL';
var LOAD_CATALOG_AD_REQUEST = exports.LOAD_CATALOG_AD_REQUEST = 'la/domain/catalogAds/LOAD_REQUEST';
var LOAD_CATALOG_AD_SUCCESS = exports.LOAD_CATALOG_AD_SUCCESS = 'la/domain/catalogAds/LOAD_SUCCESS';

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    byKeyword: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var existingByKeywords = void 0;
    var loaded = void 0;
    var loading = void 0;

    switch (action.type) {
        case LOAD_CATALOG_AD_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, [action.meta.keywords || action.meta.categoryIds])
            });
        case LOAD_CATALOG_AD_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, [action.payload])
            });
        case LOAD_CATALOG_AD_SUCCESS:
            var _action$meta = action.meta,
                categoryIds = _action$meta.categoryIds,
                keywords = _action$meta.keywords;

            existing = (0, _cloneDeep2.default)(state.byId);
            existingByKeywords = (0, _cloneDeep2.default)(state.byKeyword);
            loaded = (0, _cloneDeep2.default)(state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            loaded[keywords || categoryIds] = action.meta.actionTime;
            loading = (0, _difference2.default)(loading, [keywords || categoryIds]);
            if (keywords) {
                existingByKeywords[keywords] = action.payload.ads[0];
            } else {
                existing[categoryIds] = action.payload.ads[0];
            }

            return (0, _extends3.default)({}, state, {
                byId: existing,
                byKeyword: existingByKeywords,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalogAd;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});
var byKeywordSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byKeyword;
});
var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});
var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getAdById = exports.getAdById = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});
var getAdByKeyword = exports.getAdByKeyword = (0, _reselect.createSelector)([byKeywordSelector, idSelector], function (byKeyword, keywords) {
    return byKeyword[keywords] || {};
});

var getAd = exports.getAd = function getAd(state, categoryIds, keywords) {
    if (keywords) return getAdByKeyword(state, keywords);else if (categoryIds) return getAdById(state, categoryIds);else return {};
};

var getLoadTimeForCatalogAd = exports.getLoadTimeForCatalogAd = function getLoadTimeForCatalogAd(state, categoryIds, keywords) {
    var selector = keywords || categoryIds;
    return (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
        return loaded[id] || 0;
    })(state, selector);
};

var isCatalogAdLoading = exports.isCatalogAdLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var loadCatalogAd = function loadCatalogAd(categoryIds, keywords, pageName) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: keywords || categoryIds,
                                type: LOAD_CATALOG_AD_REQUEST
                            });
                            _context.next = 6;
                            return _api.CatalogAd.fetchCatalogAd({ categoryIds: categoryIds, deployment: deployment, keywords: keywords, pageName: pageName });

                        case 6:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), categoryIds: categoryIds, keywords: keywords },
                                payload: response.data,
                                type: LOAD_CATALOG_AD_SUCCESS
                            });
                            _context.next = 13;
                            break;

                        case 10:
                            _context.prev = 10;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { categoryIds: categoryIds, keywords: keywords },
                                payload: _context.t0,
                                type: LOAD_CATALOG_AD_FAIL
                            });

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 10]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var shouldFetchCatalogAd = function shouldFetchCatalogAd(state, categoryIds, keywords) {
    if (!categoryIds && !keywords) return false;
    var item = getAd(state, categoryIds, keywords);
    if (item) {
        var loaded = getLoadTimeForCatalogAd(state, categoryIds, keywords);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isCatalogAdLoading(state, categoryIds);
    return !loading;
};

var fetchCatalogAdIfNeeded = exports.fetchCatalogAdIfNeeded = function fetchCatalogAdIfNeeded(_ref2) {
    var categoryIds = _ref2.categoryIds,
        keywords = _ref2.keywords,
        pageName = _ref2.pageName;
    return function (dispatch, getState) {
        if (shouldFetchCatalogAd(getState(), categoryIds, keywords)) {
            return dispatch(loadCatalogAd(categoryIds, keywords, pageName));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalogAd.js
// module id = 0QM2
// module chunks = 57